import React, { useEffect, useState } from 'react';

import { collaboratorAiAllowance, setCollaboratorAiAllowance } from './api';

/**
 * The standard monthly AI allowance for people a workspace works with (migration
 * 20261231840000). A contractor or requester uses AI on a workspace's work at that
 * workspace's expense up to this many credits a month; each workspace can change its own
 * in Billing & usage, and past it the person may use their own credits.
 */
export default function CollaboratorAiAllowance({ toast }: { toast: (message: string) => void }) {
  const [credits, setCredits] = useState<number | null>(null);
  const [text, setText] = useState('');

  useEffect(() => {
    collaboratorAiAllowance()
      .then((n) => { setCredits(n); setText(String(n)); })
      .catch((e: Error) => toast(`Could not read the AI allowance: ${e.message}`));
  }, [toast]);

  const save = async () => {
    const n = Number(text.trim());
    if (!/^\d{1,6}$/.test(text.trim())) return toast('Enter a whole number of credits (0 turns it off)');
    try {
      await setCollaboratorAiAllowance(n);
      setCredits(n);
      toast(`Each outside person can now use ${n} credits a month of a workspace's AI`);
    } catch (e) {
      toast(`Refused: ${(e as Error).message}`);
    }
  };

  return (
    <div className="card" style={{ marginTop: 18 }}>
      <h2 style={{ marginTop: 0 }}>AI for people a workspace works with</h2>
      <p className="sub">
        Contractors and requesters use AI on a workspace&rsquo;s jobs, inspections and assets, paid
        from that workspace&rsquo;s credits, up to this many credits a month each. A workspace can
        set its own in Billing &amp; usage; past it, the person can use their own credits.
      </p>
      <div className="row" style={{ gap: 8, alignItems: 'center' }}>
        <input
          value={text}
          inputMode="numeric"
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && void save()}
          style={{ width: 90 }}
          aria-label="Credits a month for each person"
        />
        <span className="muted" style={{ fontSize: 12.5 }}>credits a month for each person</span>
        {credits !== null && text.trim() !== String(credits) ? (
          <button className="btn" onClick={() => void save()}>Save</button>
        ) : null}
      </div>
    </div>
  );
}
